import dayjs, { Dayjs } from 'dayjs';

export const RANGE_PRESENT: {
  label: string;
  value: [Dayjs, Dayjs];
}[] = [
  { label: 'День', value: [dayjs(), dayjs()] },
  { label: 'Неделя', value: [dayjs().add(-7, 'd'), dayjs()] },
  { label: 'Месяц', value: [dayjs().add(-30, 'd'), dayjs()] },
];
